import service from '@/store/services/people-service';

const state = {
    list: {},
    person: {},
    meta: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, person) => {
        state.person = person;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((role) => { commit('SET_RESOURCE', role); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((person) => { commit('SET_RESOURCE', person); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((person) => { commit('SET_RESOURCE', person); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    person: state => state.person,
    url: state => state.url,
    dropdown: (state) => {
        return state.list.map(person => ({
            id: person.id,
            name: person.name + ' ' + person.surname
        }));
    }
};

const people = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default people;